import {Component, OnInit, ViewChild} from "@angular/core";

import {GerenciadorRegistroComponent} from "../gerenciador-registro/gerenciador-registro.component";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {PageService} from "../../shared/layout/services/page.service";
import {RegraCompostaStepperComponent} from "./regra-composta-stepper/regra-composta-stepper.component";
import {TipoUpload} from "../../shared/importacao-lote/tipo-upload";
import {RegraService} from "../regra.service";
import {Observable, Subscription} from "rxjs";
import {Exporter, XLSXExporter} from "../../shared/export/export";
import {HttpResponse} from "@angular/common/http";
import {ToastService} from "maps-angular-components";

@Component({
    selector: "regra-composta",
    templateUrl: "./regra-composta.component.html",
    styleUrls: ["./regra-composta.component.scss"],
})
export class RegraCompostaComponent implements OnInit {

    @ViewChild("regraCompostaStepper", {static: false}) regraCompostaStepper: RegraCompostaStepperComponent;
    @ViewChild("gerenciadorRegistrosComposta", {static: false}) gerenciadorRegistrosComposta: GerenciadorRegistroComponent;
    readonly  tipo = TipoUpload.REGRA_COMPOSTA;
    private readonly subscriptions = new Subscription();

    constructor(private page: PageService,
                private service: RegraService,
                private messageService: ToastService) {
    }

    ngOnInit() {
        this.page.defineTitle("REGRA COMPOSTA");
    }

    tabChanged($event: MatTabChangeEvent): void {
        if ($event.index === 0) {
            this.regraCompostaStepper.limpar();
        } else if ($event.index === 2) {
            this.gerenciadorRegistrosComposta.limparForm();
        }
    }

    downloadModelo(){
        const exporter = new XLSXExporter();
        this.doExportPage(this.service.downloadModelo(), exporter);
    }

    doExportPage(observableData: Observable<HttpResponse<Blob>>, exporter: Exporter) {
        this.subscriptions.add(observableData.subscribe(
            (data: HttpResponse<Blob>) => exporter.save(data),
            err => this.messageService.erro(err.error.message)
        ));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
